// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main[data-v-76528954]{position:relative;background-color:#f7f7f7;height:100%}.main-blue[data-v-76528954]{z-index:1;position:fixed}.main-blue-background[data-v-76528954]{width:100%}.main-blue-user-info[data-v-76528954]{position:absolute;display:flex;align-items:center;top:16.53333vw;left:8.26667vw}.main-white[data-v-76528954]{position:absolute;top:14.66667vw;box-sizing:border-box;width:100%;padding:16.53333vw 4.26667vw 0}", ""]);
// Exports
module.exports = exports;
